export default __webpack_public_path__ + "static/progress-975554dde4ee982fa6706260e3123844.png";